import AcademiaButton from '../Buttons/AcademiaButton';
import ParentModal from './ParentModal';

const ConsentModal = ({
  titleText,
  subTitle,
  yesBtnVariant,
  yesBtnTxt,
  noBtnVariant,
  noBtnTxt,
  isLoading,
  handleModalClose,
  mutationHandler,
}: {
  titleText: string;
  subTitle: React.ReactNode;
  isLoading: boolean;
  yesBtnTxt: string;
  noBtnTxt: string;
  yesBtnVariant: 'primary' | 'danger' | 'success';
  noBtnVariant: 'primary' | 'danger' | 'success';
  handleModalClose: () => void;
  mutationHandler: () => void;
}) => {
  // rendering custom consent modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <div className='text-left text-base space-y-3'>
        <h2 className='font-semibold text-base-orange text-2xl capitalize italic'>
          {titleText}
        </h2>

        <p className='text-left whitespace-pre-wrap text-legal-dark-blue'>
          {subTitle}
        </p>

        <div className='flex items-center justify-center md:justify-end gap-3 !mt-5'>
          <AcademiaButton
            onClick={mutationHandler}
            type='submit'
            variant={yesBtnVariant}
            customWidth={150}
            isLoading={isLoading}
            additionalClassNames='!py-2'
          >
            {yesBtnTxt}
          </AcademiaButton>

          <AcademiaButton
            onClick={handleModalClose}
            type='button'
            customWidth={150}
            variant={noBtnVariant}
            additionalClassNames='!py-2'
          >
            {noBtnTxt}
          </AcademiaButton>
        </div>
      </div>
    </ParentModal>
  );
};

export default ConsentModal;
